import YFormPanel from './Panel';

export { YFormPanel };
export default YFormPanel;
